import { Col, Row, Image, Modal } from "antd";
import React, { useState } from "react";
import { Texts } from "../DetailTab";
import { dateFormatter, numberFormatter } from "../../../../../utility/Formatter";
import { color, icon } from "../../../../../resource";
import styled from "styled-components";
import Text from "../../../../../components/Text/Text";
import Button from "../../../../../components/Button/Button";
import { EstimatePointFormatter } from "../../../../../utility/EstimatePointFormatter";
import type { PointDetailEntity } from "../../../../../entities/PointApproveEntity";
import { useNavigate } from "react-router-dom";

const ClickableImage = styled.img`
  width: 20px;
  height: 22px;
  margin-right: 8px;
`;
interface Props {
  data: PointDetailEntity;
  grouped: any;
  modalIsCheck: () => void;
}
function DetailSDL({ data, grouped, modalIsCheck }: Props) {
  const navigate = useNavigate();
  const orderPointId = window.location.pathname.split("/")[3];
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row gutter={[16, 16]} style={{ marginBottom: 12 }}>
        <Col xs={24} sm={12} md={12} lg={12}>
          <Row gutter={[0, 12]} style={{ marginBottom: 10 }}>
            <Col span={10}>
              <Texts>เลขที่ส่งเอกสาร :</Texts>
            </Col>
            <Col span={14} style={{ display: "flex", alignItems: "center" }}>
              <Texts style={{ marginRight: 8 }}>{data?.orderPointCode}</Texts>
              <Texts style={{ color: color.placeholder }}>{`(${dateFormatter(
                data.createAt,
                true,
              )})`}</Texts>
            </Col>
          </Row>
          <Row gutter={[0, 12]} style={{ marginBottom: 10 }}>
            <Col span={10}>
              <Texts>ร้านที่ซื้อ (Sub-Dealer) :</Texts>
            </Col>
            <Col span={14}>
              <Texts>{data.subDealerName}</Texts>
              <Texts style={{ color: color.placeholder }}>
                {data.subDealerNo} {data.subDealerNo || data.subDealerZone ? "•" : "-"}{" "}
                {data.subDealerZone}
              </Texts>
            </Col>
          </Row>
          <Row gutter={[0, 12]}>
            <Col span={10}>
              <Texts>ร้านที่ขาย (Dealer) :</Texts>
            </Col>
            <Col span={14}>
              <Texts>{data.dealerName}</Texts>
              <Texts style={{ color: color.placeholder }}>
                {data.dealerNo} {data.dealerNo || data.dealerZone ? "•" : "-"} {data.dealerZone}
              </Texts>
            </Col>
          </Row>
        </Col>

        <Col xs={24} sm={12} md={12} lg={12}>
          <Row gutter={[0, 12]} style={{ marginBottom: 10 }}>
            <Col span={12}>
              <Texts>วันที่ขน :</Texts>
            </Col>
            <Col span={12}>
              <Texts>{dateFormatter(data.dateDelivery)}</Texts>
            </Col>
          </Row>
          <Row gutter={[0, 12]} style={{ marginBottom: 10 }}>
            <Col span={12}>
              <Texts>ภาพใบขน :</Texts>
            </Col>
            <Col span={12}>
              {data.subDealerName ? (
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 4,
                  }}
                  onClick={() => window.open(`/crm/previewShipDoc/${orderPointId}`, "_blank")}
                >
                  <ClickableImage src={icon.viewDoc} alt='View Document' />
                  <Texts style={{ color: color.primary }} onClick={() => setVisible(true)}>
                    ดูภาพใบขน
                  </Texts>
                  {/* <Image
                    style={{ display: "none" }}
                    src={data.deliverySheet}
                    preview={{
                      visible,
                      src: `${data.deliverySheet}`,
                      onVisibleChange: (value) => {
                        setVisible(value);
                      },
                    }}
                  /> */}
                </div>
              ) : (
                <Text color='placeholder'>-</Text>
              )}

              {data.subDealerName && data.status !== "CANCEL" && (
                <Button
                  icon={
                    <img
                      src={!data.isChecked ? icon.checkCRM : icon.cancelCRM}
                      style={{ width: 20, height: 20 }}
                    />
                  }
                  typeButton={!data.isChecked ? "primary" : "danger"}
                  title={!data.isChecked ? "ยืนยันความถูกต้องของใบขน" : "ยกเลิกการตรวจสอบ"}
                  style={{ width: "max-content" }}
                  onClick={modalIsCheck}
                />
              )}
            </Col>
          </Row>
          <Row gutter={[0, 12]} style={{ marginBottom: 10 }}>
            <Col span={12}>
              <Texts>ยอดแต้มที่ได้รับ :</Texts>
            </Col>
            <Col span={12}>
              <Texts>
                <EstimatePointFormatter historyOrderPoint={data.historyOrderPoint} page='detail' />
                &nbsp;
                {numberFormatter(data.sumPoint, 2)} แต้ม
              </Texts>
            </Col>
          </Row>
          <Row gutter={[0, 12]} style={{ marginBottom: data.status === "REJECT" ? 10 : 0 }}>
            <Col span={12}>
              <Texts>ยอดตันที่เข้าร่วม</Texts>
            </Col>
            <Col span={12}>
              <Texts>{numberFormatter(data.sumQuantity, 2)} ตัน</Texts>
            </Col>
          </Row>
          {data.status === "REJECT" && (
            <Row gutter={[0, 12]}>
              <Col span={12}>
                <Texts style={{ color: color.error }}>เหตุผลไม่อนุมัติ :</Texts>
              </Col>
              <Col span={12}>
                <Texts>{data.reason}</Texts>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default DetailSDL;
